import React, { useContext, useReducer } from "react";
import axios from "axios";
import AdSetContext from "./AdSetContext";
import AdSetReducer from "./AdSetReducer";
import {
  FACEBOOK_ADSET_FORM_DETAILS,
  FACEBOOK_ADSET_FORM_ERROR,
  FACEBOOK_ADSET_ID,
  FACEBOOK_ADSET_ERROR,
} from "../../types";

// Contexts
// import AuthContext from "../../auth/AuthContext";
import LayoutContext from "../../layout/LayoutContext";
import DashboardContext from "../../facebook_profiles/dashboard/DashboardContext";

const AdSetState = (props) => {
  const default_form = {
    name: "",
    countries: ["US"],
    billing_event: "IMPRESSIONS",
    optimization_goal: "OFFSITE_CONVERSIONS",
    pixel_id: "",
    custom_event_type: "PURCHASE",
    spec_event_type: "CLICK_THROUGH",
  };

  const default_error = {
    name: "",
    countries: "",
    billing_event: "",
    optimization_goal: "",
    pixel_id: "",
    custom_event_type: "",
    spec_event_type: "",
  };

  const initialState = {
    list_delivery: [
      "ALL",
      "ACTIVE",
      "PAUSED",
      "DELETED",
      "CAMPAIGN_PAUSED",
      "ARCHIVED",
      "IN_PROCESS",
      "WITH_ISSUES",
    ],
    list_countries: {
      US: "United States",
    },
    list_billing_event: [
      "APP_INSTALLS",
      "CLICKS",
      "IMPRESSIONS",
      "LINK_CLICKS",
      "NONE",
      "OFFER_CLAIMS",
      "PAGE_LIKES",
      "POST_ENGAGEMENT",
      "THRUPLAY",
    ],
    list_optimization_goal: [
      "NONE",
      "APP_INSTALLS",
      "BRAND_AWARENESS",
      "AD_RECALL_LIFT",
      "CLICKS",
      "ENGAGED_USERS",
      "EVENT_RESPONSES",
      "IMPRESSIONS",
      "LEAD_GENERATION",
      "QUALITY_LEAD",
      "LINK_CLICKS",
      "OFFER_CLAIMS",
      "OFFSITE_CONVERSIONS",
      "PAGE_ENGAGEMENT",
      "PAGE_LIKES",
      "POST_ENGAGEMENT",
      "QUALITY_CALL",
      "REACH",
      "SOCIAL_IMPRESSIONS",
      "APP_DOWNLOADS",
      "TWO_SECOND_CONTINUOUS_VIDEO_VIEWS",
      "LANDING_PAGE_VIEWS",
      "VISIT_INSTAGRAM_PROFILE",
      "VALUE",
      "THRUPLAY",
      "REPLIES",
      "DERIVED_EVENTS",
    ],
    list_custom_event_type: [
      "RATE",
      "TUTORIAL_COMPLETION",
      "CONTACT",
      "CUSTOMIZE_PRODUCT",
      "DONATE",
      "FIND_LOCATION",
      "SCHEDULE",
      "START_TRIAL",
      "SUBMIT_APPLICATION",
      "SUBSCRIBE",
      "ADD_TO_CART",
      "ADD_TO_WISHLIST",
      "INITIATED_CHECKOUT",
      "ADD_PAYMENT_INFO",
      "PURCHASE",
      "LEAD",
      "COMPLETE_REGISTRATION",
      "CONTENT_VIEW",
      "SEARCH",
      "SERVICE_BOOKING_REQUEST",
      "MESSAGING_CONVERSATION_STARTED_7D",
      "LEVEL_ACHIEVED",
      "ACHIEVEMENT_UNLOCKED",
      "SPENT_CREDITS",
      "LISTING_INTERACTION",
      "D2_RETENTION",
      "D7_RETENTION",
      "OTHER",
    ],
    list_spec_event_type: ["CLICK_THROUGH", "VIEW_THROUGH"],
    form_details: [],
    form_errors: [],
    adset_id: [],
    adset_error: null,
  };

  const [state, dispatch] = useReducer(AdSetReducer, initialState);
  // const { user } = useContext(AuthContext);
  const { setLoading, setAlert } = useContext(LayoutContext);
  const { setDisplayContent } = useContext(DashboardContext);

  const setFormDetails = (details) => {
    dispatch({
      type: FACEBOOK_ADSET_FORM_DETAILS,
      payload: details,
    });
  };

  const setFormErrors = (errors) => {
    dispatch({
      type: FACEBOOK_ADSET_FORM_ERROR,
      payload: errors,
    });
  };

  const resetForm = () => {
    dispatch({
      type: FACEBOOK_ADSET_FORM_DETAILS,
      payload: [],
    });
    dispatch({
      type: FACEBOOK_ADSET_FORM_ERROR,
      payload: [],
    });
  };

  const createAdSet = async (profile_id, ad_account, campaign_id) => {
    setLoading(true);

    let details = [];

    state.form_details.map((each) => {
      details.push({
        name: each.name,
        targeting: {
          geo_locations: {
            countries: each.countries,
          },
        },
        billing_event: each.billing_event,
        optimization_goal: each.optimization_goal,
        promoted_object: {
          pixel_id: each.pixel_id,
          custom_event_type: each.custom_event_type,
        },
        attribution_spec: [
          {
            event_type: each.spec_event_type,
            window_days: 1,
          },
        ],
      });
    });

    try {
      const res = await axios.post("/api/facebook_adset/createAdset", {
        details,
        profile_id,
        ad_account,
        campaign_id,
      });

      if (res.data.adset_id) {
        dispatch({
          type: FACEBOOK_ADSET_ID,
          payload: res.data.adset_id,
        });
        setDisplayContent("Ad");
        resetForm();
      }

      if (res.data.error) {
        setAlert(
          `${res.data.error.message} - ${res.data.error.error_user_msg}`,
          "error"
        );
      }
    } catch (err) {
      dispatch({
        type: FACEBOOK_ADSET_ERROR,
        payload: err.response,
      });
    }

    setLoading(false);
  };

  return (
    <AdSetContext.Provider
      value={{
        default_form,
        default_error,
        list_delivery: state.list_delivery,
        list_countries: state.list_countries,
        list_billing_event: state.list_billing_event,
        list_optimization_goal: state.list_optimization_goal,
        list_custom_event_type: state.list_custom_event_type,
        list_spec_event_type: state.list_spec_event_type,

        form_details: state.form_details,
        form_errors: state.form_errors,
        adset_id: state.adset_id,
        // adset_error: state.adset_error,
        setFormDetails,
        setFormErrors,
        resetForm,
        createAdSet,
      }}
    >
      {props.children}{" "}
    </AdSetContext.Provider>
  );
};

export default AdSetState;
